<script setup lang="ts">
import Init from './components/Init.vue';
import TheGame from './components/TheGame.vue';
import Results from './components/Results.vue';
import useWordOfTheDayStore from './store';
import { storeToRefs } from 'pinia';
import ChalkBoardLayout from './layout/ChalkBoardLayout.vue';

const store = useWordOfTheDayStore();
const { gameState: state } = storeToRefs(store);

const emits = defineEmits<{ (e: 'goBack'): void }>();
</script>

<template>
  <ChalkBoardLayout @go-back="emits('goBack')">
    <Init v-if="state === 'init'"></Init>
    <TheGame v-else-if="state === 'game' || state === 'game-over'"></TheGame>
    <Results v-else-if="state === 'results'"></Results>
  </ChalkBoardLayout>
</template>

<style scoped lang="scss">
@use 'vuetify/settings';

:deep(.action-btn) {
  @media screen and (min-width: 1440px) {
    font-size: 1.5rem !important;
  }
}
</style>
